<template>
    <div class="text-left">
  <b-button-group>
    <b-button v-if="currentPageName != 'main'" href="/">Home</b-button>
    <b-button v-if="currentPageName != 'main'" href="/demo">Example</b-button>
    <b-button v-if="currentPageName != 'main'" v-on:click="enableUpdateMode">Update</b-button>
  </b-button-group>
</div>
</template>

<script>
//import {mapState} from 'vuex';

export default {
    name: "NavBar",
    props: ['currentPageName'],
    created: function() {
        console.log('nav: ', this.currentPageName);
    },

    methods: {
        enableUpdateMode() {
            this.$store.commit('setUpdateMode', !this.$store.state.updateMode)
        }
    },
}
</script>